export default [
    {
        path: '/',
        redirect: '/home',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/Profile.vue'),
        meta: {
            requiresAuth: true,
            layout: 'contact',
        }
    },
    {
        path: '/subscription-due/:companyId',
        name: 'SubscriptionDue',
        component: () => import('@/views/SubscriptionDue.vue'),
        meta: {
            requiresAuth: true,
            layout: 'contact',
        }
    },
    {
        path: '/email',
        name: 'Email',
        component: () => import('@/views/Email.vue'),
    }
]